import React, { useEffect, useRef, useState } from 'react';
import { ThemeProvider } from 'styled-components';
function DesignSystemThemeProvider(_ref) {
  let {
    children,
    theme
  } = _ref;
  const [currentTheme, setCurrentTheme] = useState(theme);
  const previousTheme = useRef(theme);
  useEffect(() => {
    if (theme !== previousTheme.current) {
      setCurrentTheme(theme);
      previousTheme.current = theme;
    }
  }, [theme]);
  useEffect(() => {
    function handleThemeChange(event) {
      setCurrentTheme(event.detail);
    }
    window.addEventListener('design-system-change-theme', handleThemeChange);
    return () => {
      window.removeEventListener('design-system-change-theme', handleThemeChange);
    };
  }, []);
  return React.createElement(ThemeProvider, {
    theme: currentTheme,
    "data-component": "DesignSystemThemeProvider"
  }, children);
}
export { DesignSystemThemeProvider };